import { Cancel, Check, Close, Save } from "@mui/icons-material";
import { CircularProgress, Dialog, DialogActions, DialogTitle } from "@mui/material";
import { Formik } from "formik";
import { isEmpty } from "lodash";
import { useEffect, useRef, useState } from "react";
import { useSelector } from "react-redux";
import { useNavigate, useParams } from "react-router-dom";
import Api from "../../api2";
import Helper from "../../helpers";
import { commonReducerSelector, userSelector } from "../../redux/selector";
import {
  MyBreadCrumbs,
  MyButton,
  MyForm,
  MyTable,
  MyTextFieldArea,
  MyThaoTac,
  ThongBao,
  scrollToError
} from "../Lib/componentLibrarys";
import { ValidateSchema } from "./validate";
import { FormNhap } from "./form";
import { parseDataSave, propsToInitialState } from "./models";
import Api_DanhMuc from "../../api_danhmuc";
import { Constant } from "../../constants/constant";

const RoutesThongTinLichSuPhanPhoi = [
  {
    path: "",
    main: () => <ThongTinLichSuPhanPhoi />
  },
  {
    path: "add",
    main: () => <HandleThongTinLichSuPhanPhoi />
  },
  {
    path: "edit/:id",
    main: () => <HandleThongTinLichSuPhanPhoi />
  },
  {
    path: "detail/:id",
    main: () => <HandleThongTinLichSuPhanPhoi view={true} />
  }
];
export default RoutesThongTinLichSuPhanPhoi;

function ThongTinLichSuPhanPhoi() {
  const [dataFormik, setFormik] = useState({
    search: "",
    limit: 10,
    anchor: 0
  });
  const common = useSelector(commonReducerSelector);
  const profile = common?.profile?.data;
  const [rawData, setRawData] = useState({});
  const [Count, setCount] = useState();
  const [data, setData] = useState([]);
  const formikRef = useRef();
  const trangThaiMuaList = Constant?.TrangThaiMuaPhanPhoi;

  //for table method
  const navigate = useNavigate();

  const parseSearchForm = values => {
    const tuKhoa = values?.search?.length > 0 ? values?.search : "";
    const limit = values?.limit ? values.limit : 10;
    const anchor = values?.anchor ? values.anchor : 0;
    const page = values?.page || "";
    return { tuKhoa, limit, anchor, page };
  };

  useEffect(() => {
    const values = formikRef.current?.values;
    getApi(parseSearchForm(values));
  }, []);
  const getRows = (limit, anchor, page) => {
    const values = formikRef.current?.values;
    getApi(parseSearchForm({ ...values, limit, anchor, page }));
  };

  const getApi = ({ tuKhoa, limit, anchor, page }) => {
    new Api()
      .GetListThongTinLichSuPhanPhoi({ tuKhoa, limit, anchor })
      .then(res => {
        if (res.code === 200) {
          setData(
            Helper.addSttToTableDataSource(res.data.records, page, limit)
          );
          setRawData(res.data);
        }
        if (res.data?.count) {
          setCount(res.data?.count);
        }
      })
      .catch(err => {});
  };
  const onSubmitSearch = () => {
    const values = formikRef.current?.values;
    getApi(parseSearchForm(values));
  };
  const columns = ({ handleEdit, handleDelete }) => {
    var column = [
      {
        headerName: "STT",
        field: "stt",
        width: "100px",
        suppressSizeToFit: true,
        pinned: "left",
        cellStyle: { justifyContent: "center" },
        headerClass: "ag-grid-header-center"
      },
      { headerName: "Mã phiếu mua", field: "maPhieuMua", width: "200px" },
      { headerName: "Tên hàng hóa", field: "tenHangHoa", width: "200px" },
      {
        headerName: "Ngày mua",
        field: "ngayMua",
        width: "200px",
        cellStyle: { justifyContent: "center" },
        headerClass: "ag-grid-header-center",
        cellRenderer: prams => {
          return (
            <div>{Helper.formatDate(prams?.data?.ngayMua * 1000)}</div>
          );
        }
      },
      {
        headerName: "Số lượng",
        field: "soLuong",
        width: "200px",
        suppressSizeToFit: true,
        cellRendererFramework: prams => {
          let dataReturn = null;
          if (prams?.data?.soLuong) {
            dataReturn = (
              <div>
                {" "}
                {String(prams?.data?.soLuong || 0)
                  .replace(".", ",")
                  .replace(/(\d)(?=(\d\d\d)+(?!\d))/g, "$1.")}
              </div>
            );
          }
          return dataReturn;
        }
      },
      {
        headerName: "Trạng thái",
        field: "trangThaiMua",
        minWidth: 200,
        flex: 1,
        cellRendererFramework: (params) => {
          let dataReturn = null
          if (params?.data?.trangThaiMua) {
            dataReturn = trangThaiMuaList?.find(item => item?.id === params.data.trangThaiMua)?.ten
          }
          return dataReturn
        }
      },
      {
        headerName: "Thao tác",
        width: "100px",
        pinned: "right",
        cellStyle: { justifyContent: "center" },
        cellRendererFramework: prams => (
          <MyThaoTac
            prams={prams}
            handleEdit={profile?.cap !== 0 && handleEdit}
            handleDelete={profile?.cap !== 0 && handleDelete}
            handleDetail={handleDetail}
          />
        ),
        headerClass: "ag-grid-header-center"
      }
    ];
    return column;
  };

  const handleEdit = params => {
    if (!params?.id) {
      ThongBao({ status: "warn", message: "ID không tồn tại" });
    }
    navigate(`edit/${params?.id || undefined}`);
  };
  const handleAdd = data => {
    navigate(`add`);
  };
  const handleDelete = params => {
    new Api()
      .DeleteThongTinLichSuPhanPhoiById({ id: params?.id })
      .then(res => {
        if (res.code === 200) {
          const values = formikRef.current.values;
          getApi(parseSearchForm(values));
          ThongBao({ status: "success", message: "Xóa thành công" });
        } else {
          ThongBao({ status: "error", message: res?.message || "Đã có lỗi xảy ra" });
        }
      })
      .catch(err => {});
  };
  const handleDetail = (data) => {
    if (!data?.id) {
      ThongBao({ status: "warn", message: "ID không tồn tại" });
      return;
    }
    navigate(`detail/${data?.id || undefined}`);
  }

  return (
    <div className="divMain">
      <MyBreadCrumbs title={[{ name: "Vận hành" }, { name: "Lịch sử thông tin phân phối" }]} />
      <MyForm
        formikRef={formikRef}
        showSearch={true}
        dataFormik={dataFormik}
        handleAdd={handleAdd}
        editable={true}
        onSubmitAPI={onSubmitSearch}
        marginBottom={"15px"}
        cannotCreate={profile?.cap === 0}
      />
      <MyTable
        autofit={true}
        columns={columns({
          editable: true,
          handleEdit: handleEdit,
          handleDelete: handleDelete
        })}
        data={data}
        pagination={{
          rawData: rawData,
          setData: setData,
          getRows: getRows,
          Count: Count
        }}
      />
    </div>
  );
}

function HandleThongTinLichSuPhanPhoi({ view }) {
  const navigate = useNavigate();
  const user = useSelector(userSelector);
  const [isLoading, setIsLoading] = useState(false);
  const { id } = useParams();
  const [data, setData] = useState(null);
  const common = useSelector(commonReducerSelector);
  const profile = common?.profile;
  const formRef = useRef(null);

  const [coSoCheBienList, setCoSoCheBienList] = useState(null);
  const [loHangList, setLoHangList] = useState(null);
  const trangThaiMuaList = Constant?.TrangThaiMuaPhanPhoi;

  //ref just for use scroll when error validate
  const refI = useRef(null);

  useEffect(() => {
    if (id && !data) {
      setIsLoading(true);
      new Api()
        .GetThongTinLichSuPhanPhoiById({ id: id })
        .then(data => {
          if (data.code === 200) {
            setData(data?.data);
          }
        })
        .catch(err => {})
        .finally(() => {
          setIsLoading(false);
        });
    }
    if (isEmpty(coSoCheBienList)) {
      new Api().GetListCoSoCheBien().then(data => {
        if (data.code === 200) {
          setCoSoCheBienList(data?.data?.records);
        }
      });
    }
    if (isEmpty(loHangList)) {
      new Api().GetListLoHang({}).then(data => {
        if (data.code === 200) {
          setLoHangList(data?.data?.records);
        }
      });
    }
  }, [id]);

  if (isLoading) {
    return (
      <div className="style-loading">
        <CircularProgress />
      </div>
    );
  }

  //set initial data
  const initialState = propsToInitialState(data, coSoCheBienList, loHangList, trangThaiMuaList);

  //List form
  const formNhap = (
    <Formik
      innerRef={f => (formRef.current = f)}
      i
      initialValues={initialState}
      enableReinitialize={true}
      validateOnBlur={false}
      validateOnChange={false}
      validationSchema={ValidateSchema}
    >
      {({ values, errors, handleSubmit, setFieldValue }) => (
        <form onSubmit={handleSubmit}>
          {/* div just for use scroll when error validate */}
          <div ref={refI}></div>
          <FormNhap
            view={view}
            values={values}
            errors={errors}
            setFieldValue={setFieldValue}
            coSoCheBienList={coSoCheBienList}
            loHangList={loHangList}
            trangThaiMuaList={trangThaiMuaList}
          />
        </form>
      )}
    </Formik>
  );

  //handle when submit API
  const handleSave = async () => {
    await formRef.current.validateForm();

    if (!isEmpty(formRef.current.errors)) {
      scrollToError(refI);
      ThongBao({
        status: "warn",
        message: "Yêu cầu nhập đầy đủ các trường có dấu đỏ"
      });
      return;
    }

    new Api()
      .UpsertThongTinLichSuPhanPhoi({
        token: user.access_token,
        data: parseDataSave(formRef.current.values, profile)
      })
      .then(res => {
        if (!res || res.code !== 200) {
          ThongBao({ status: "error", message: res?.message || "Đã có lỗi xảy ra" });
          return;
        }
        ThongBao({ status: "success", message: "Thành công" });
        navigate(-1);
      })
      .catch(err => {
        ThongBao({ status: "error", message: "Đã có lỗi xảy ra" });
      })
      .finally(() => {});
  };

  return (
    <>
      <div
        style={{
          display: "flex",
          flexDirection: "column",
          paddingBottom: "0.875rem"
        }}
      >
        <MyBreadCrumbs
          title={[
            { name: "Vận hành" },
            { name: "Lịch sử thông tin phân phối", link: -1 },
            { name: `${id ? "Cập nhật " : "Thêm mới"}` }
          ]}
        />
        {formNhap}
      </div>
      <div
        style={{
          display: "flex",
          justifyContent: "flex-end",
          marginBottom: 15
        }}
      >
        <MyButton
          onClick={() => navigate(-1)}
          txt="Hủy bỏ"
          color="#888"
          style={{ width: 130, height: 33, marginTop: 5 }}
          icon={<Cancel />}
        />
        <p style={{ width: 5 }}></p>
        {
          !view && (
            <MyButton
              onClick={() => {
                handleSave();
              }}
              txt="Lưu thông tin"
              style={{ width: 130, height: 33, marginTop: 5 }}
              icon={<Save />}
            />
        )}
      </div>
    </>
  );
}
